import { createFileRoute } from "@tanstack/react-router"
import { BlacklistPage } from "@/pages/profile/blacklist"

export const Route = createFileRoute("/_authenticated/profile/blacklist/")({
	component: BlacklistPage,
})
